import React from 'react'
import Helmet from 'react-helmet'

const Merken = (props) => (
    <div>
        <Helmet
            title="Algemene Voorwaarden | Gifture"
        />
        <div className="hero is-primary">
            <div className="hero-body">
                <div className="container has-text-centered">
                    <h1 className="title">Producten, diensten en merken van Gifture Concepts</h1>
                </div>
            </div>
        </div>
        <div className="section">
            <div className="container">
                <div className="columns">
                    <div className="column">
                        <div className="content">
                            <p>
                                Gifture Photobooth is onderdeel van Gifture Concepts. <br/>
                                Naast de photobooth verhuur hebben wij meerdere niche-webshops, waaronder:
                            </p>
                            <h3>KabelBeestjes.nl</h3>
                            <p>
                                De nieuwste rage in Nederland is te koop bij <a href="https://www.kabelbeestjes.nl/alle-kabelbeestjes" title="Verkoop Cable Munchers / Cable Bites / Kabel Beestjes in Nederland">Kabel Beestjes.</a><br/>
                                Kabel Beestjes (ookwel <a href="https://www.kabelbeestjes.nl/alle-cable-munchers" title="Cable Munchers kopen (Nederland)">Cable Munchers</a> of <a href="https://www.kabelbeestjes.nl/alle-cable-bites" title="Cable Bites kopen (Nederland)">Cable Bites</a> genoemd) zijn schattige diertjes die je op je oplaadkabel kunt klikken. <br/>
                                Naast dat ze er super schattig uit zien, zijn het ook nog eens hele handige <a href="https://www.kabelbeestjes.nl" title="Kabelbeschermer kopen (Nederland)">oplaadkabel beschermers</a>.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default Merken;



// WEBPACK FOOTER //
// ./src/pages/gifture-merken.js